import { Header, Left, Body, Right, Content, Title, Button, H2, List, Container, Icon, Text, H3, ListItem, Thumbnail, View, Tabs, Tab, Spinner } from 'native-base';
import { Platform, Linking, StyleSheet, Image, Animated } from 'react-native';
import React, { useState, useEffect, useCallback } from 'react';
import * as WebBrowser from 'expo-web-browser';
import HamburgerMenu from '../../components/hamburgerMenu';
import CalCalDataApi from '../../api/CalCalDataApi';
import { useSelector, shallowEqual } from 'react-redux';
import Alert from '../../components/alert';
import Transactions from './transactions';
import useScreenDimensions from '../../hooks/screenDimensions';
import AnimatedSearchBar from '../../components/animatedSearchBar';
import useSidebarStyle from '../../hooks/sidebarStyle';
import AccountPopup from './accountPopup';
import XDate from 'xdate';

export default function BankImport({ navigation }) {
	const { width, height } = useScreenDimensions();

	const { user, jwt, busDetails } = useSelector(
		state => ({
			user: state.loginReducer.user,
			jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
			busDetails: state.globalReducer.busDetails
		}),
		shallowEqual
	);

	const redirectUrl = Platform.OS == 'web' ? window.location.origin + '/redirect' : 'calcal://BankImport';
	const [connectedNew, setConnectedNew] = useState(false);
	const [accounts, setAccounts] = useState([]);
	const [credentials, setCredentials] = useState([]);
	const [connectedAny, setConnectedAny] = useState(0);
	const [checkedConnection, setCheckedConnection] = useState(false);
	const [tab, setTab] = useState(0);
	const [linkToken, setLinkToken] = useState();

	//const [tinkLink, setTinkLink] = useState(null); // do we have the link?

	const [searching, setSearching] = useState(false);
	const [searchString, setSearchString] = useState(false);

	const { drawerType } = useSidebarStyle();
	//if (busDetails) setConnectedAny(busDetails.tinkConnected);

	useEffect(() => {
		if (connectedAny == 1 || (connectedAny == 0 && checkedConnection)) return; //we just set it here, or we're sure no connections

		//get credentials list
		CalCalDataApi.dataLoad('bankimport/credentials', jwt, res => {
			setCheckedConnection(true);
			if (res.success) {
				setCredentials(res.creds); //having creds will enable the transactions tab
				//setTab(1);
				setConnectedAny(1);
				const accounts = res.creds.reduce((accumulator, currentValue, currentIndex, array) => {
					accumulator.push(...currentValue.accounts);
					return accumulator;
				}, []);
				setAccounts(accounts);
				//get accounts
				/*CalCalDataApi.dataLoad('bankimport/accounts', jwt, res => {
					res.success && setAccounts(res.accounts);
					res.accounts.forEach(v => {
						//if (v.calcalId) setTab(0);
					});
				});*/
			} else if (res.status && res.status == 403) {
				//setError({ loading: 'pre-population', error: 'Not licensed' });
				Alert.alert('Not yet licensed', `You need to subscribe to use bank import.`, [
					{ text: 'Pay later', onPress: () => navigation.goBack() },
					{ text: 'Pay now', onPress: () => navigation.navigate('SubscriptionContainer') }
				]);
			} else if (res.status && res.status == 404) {
				setConnectedAny(0);
			}
		});
	}, [connectedAny]);

	const [categories, setCategories] = useState();
	useEffect(() => {
		//get categories- use our back end to enable client cache with etag
		CalCalDataApi.dataLoad('bankimport/categories', jwt, res => {
			res.success && setCategories(res.categories);
		});
	}, []);
	/*
	const urlCallback = event => {
		//mobile app
		if (handledCallback) return;
		setHandled(true);
		//this.urlCallback && Linking.removeEventListener('url', this.urlCallback);
		console.log('urlCallback', event.url);

		if (event.url.split('error=').length > 1) {
			const error = event.url.split('message=')[1];
			Alert.alert('Error', decodeURIComponent(error));
		} else {
			const code = event.url.split('code=')[1].split('&')[0];

			CalCalDataApi.dataInsert('bankimport/code', { code }, jwt, res => {
				if (res.success) {
					//setConnected(true);
					//console.log('access-token', res);
					setConnectedAny(connectedAny + 2); //pull credentials and accounts
					//launch a pop-up so they can link the account with a calcal one?
				} else {
					//setError({ loading: 'code', error: res.error.error || res.error });
				}
			});
		}
	};
*/
	//open web browser
	const [handledCallback, setHandled] = useState(false);
	const doConnect = async tinkUrl => {
		if (!tinkUrl) return Alert.alert('Error', 'Not got auth url. Please try again later');
		setHandled(false);
		//Linking.addEventListener('url', ev => urlCallback(ev));
		const result = await WebBrowser.openAuthSessionAsync(tinkUrl, redirectUrl);
		__DEV__ && console.log(result);
		//web browser
		if (result && result.type == 'success' && result.url) {
			if (result.url.split('error=').length > 1) {
				const error = result.url.split('message=')[1];
				Alert.alert('Error', decodeURIComponent(error));
			} else if (result.url.split('exit').length > 1) {
				console.log('exit');
			} else {
				const public_token = result.url.split('public_token=')[1];
				CalCalDataApi.dataInsert('bankimport/code', { public_token }, jwt, res => {
					if (res.success) {
						//setConnected(true);
						//console.log('access-token', res);
						setConnectedAny(connectedAny + 2); //pull credentials and accounts
						//launch a pop-up so they can link the account with a calcal one?
					} else {
						//setError({ loading: 'code', error: res.error.error || res.error });
					}
				});
			}
		} else {
			if (result.error) Alert('Error', result.message || result.error);
			if (credentials.length) setConnectedAny(connectedAny + 2); //if this is a refresh, update credentials list
		}
	};

	const [searchTimeout, setSearchTimeout] = useState();
	const changeSearchText = useCallback(
		s => {
			if (searchTimeout) clearTimeout(searchTimeout);
			if (s.length < 3) {
				setSearchString(false);
			} else {
				setSearchTimeout(setTimeout(() => setSearchString(s), 500));
			}
		},
		[searchTimeout]
	);

	const [openAccount, setOpenAccount] = useState();
	const closeAccountPopup = useCallback(() => {
		setConnectedAny(connectedAny + 2); //just reload the accounts!
		setOpenAccount(null);
	}, [connectedAny]);

	const refreshLogin = credentialId => {
		CalCalDataApi.dataLoad('bankimport/credentials/update/' + credentialId + '?r=' + redirectUrl, jwt, res => {
			if (res.success) {
				//doConnect(res.url);
			}
		});
	};

	const newLogin = () => {
		CalCalDataApi.dataLoad('bankimport/link?r=' + redirectUrl, jwt, res => {
			if (res.success) {
				doConnect(res.url);
			}
		});
	};

	return (
		<Container>
			<AnimatedSearchBar
				title="Bank Import"
				isSearchActive={searching}
				onChangeText={changeSearchText}
				popupMenu={false}
				onSearchOpen={() => {
					//LayoutAnimation.linear();
					setTab(1);
					setSearching(true);
				}}
				showHamburger={drawerType != 'permanent'}
				onSearchClose={searching ? () => setSearching(false) : () => navigation.toggleDrawer()}
				emptyText="search"
				extraButton={
					<Button transparent style={{ flexWrap: 'wrap', justifyContent: 'center' }} onPress={newLogin}>
						<Icon name="add" />
						<Text style={{ fontSize: 14 }}>Connect Bank</Text>
					</Button>
				}
			/>

			<Content>
				<Tabs onChangeTab={t => setTab(t.i)} page={tab} initialPage={0}>
					<Tab heading="Accounts" style={{ height: height - 146 }}>
						{!!credentials.length && (
							<View padder>
								<H3>Connected Accounts</H3>
							</View>
						)}
						{!!checkedConnection && connectedAny == 0 && <Text style={{ textAlign: 'center', flex: 1, marginVertical: 20 }}>Press + to connect with your bank</Text>}
						<Content>
							{!checkedConnection && <Spinner />}
							<List>
								{credentials.map((cred, j) => (
									<React.Fragment key={j}>
										<ListItem itemDivider first={j == 0} style={{ backgroundColor: cred.institution.primary_color && cred.institution.primary_color + '55' }}>
											{cred.institution.logo && <Thumbnail square source={{ uri: 'data:image/png;base64,' + cred.institution.logo }} />}
											<Body>
												<Text>{cred.institution?.name}</Text>
											</Body>

											<Right>
												<Button icon transparent onPress={() => refreshLogin(cred.item.item_id)}>
													<Icon name="refresh-circle" />
												</Button>
												<Text note>{XDate(cred.item?.consent_expiration_time).toString('dd/MM/yyyy')}</Text>
											</Right>
										</ListItem>
										{cred.accounts.map((account, i) => (
											<ListItem avatar onPress={() => setOpenAccount(account)} key={i}>
												<Body>
													<Text>{account.name}</Text>
													<Text note>{account.subtype.replace('CHECKING', 'CURRENT ACCOUNT').replace('_', ' ')}</Text>
												</Body>
												{!account.calcalId && (
													<Right style={{ flex: null }}>
														<Text note style={{ color: 'red' }}>
															Not linked
														</Text>
													</Right>
												)}
												<Right style={{ flex: 0.5 }}>
													{i == 0 && <Text note>BALANCE</Text>}
													<Text>
														{account.balances?.current < 0 && '-'} {account.balances?.iso_currency_code?.replace('GBP', '£')} {Math.abs(account.balances?.current).toFixed(2)}
													</Text>
												</Right>
											</ListItem>
										))}
									</React.Fragment>
								))}
							</List>
						</Content>
					</Tab>
					{!!credentials.length && (
						<Tab heading="Transactions" style={{ height: height - 146 }}>
							<Transactions navigation={navigation} jwt={jwt} accounts={accounts} categories={categories} search={searching && searchString} />
						</Tab>
					)}
				</Tabs>
			</Content>
			<AccountPopup account={openAccount} jwt={jwt} onClosed={closeAccountPopup} />
		</Container>
	);
}
